import {ProblemDestination} from '../state/global.types';
import {APIService} from '@/services/api.service';
import {FilterTag} from '@/views/amex/app-types';
import {IntersectionalFiltersDomain, buildProblem} from './build-problem';
import {Price, CandidatePoiItem} from '@mobi-components/global-solution';
import {TravelersIndormation} from './submit-amex-problem';

export interface NearbyLocationsResponse {
  contexts: CandidatePoiItem[];
  isDestAvailable: boolean;
}

export async function downloadDestinationAlternatives(
  id: string,
  userId: string,
  origin: ProblemDestination,
  destination: ProblemDestination,
  tags: FilterTag[],
  budget: Price[],
  travelersInformation: TravelersIndormation,
  intersectionalFilters: IntersectionalFiltersDomain,
): Promise<NearbyLocationsResponse> {
  const problem = buildProblem(
    id,
    userId,
    origin,
    destination,
    tags,
    budget,
    travelersInformation,
    intersectionalFilters,
  );

  try {
    const {contexts = [], has_matched_destinations: isDestAvailable} = await APIService.post<{
      contexts: CandidatePoiItem[];
      has_matched_destinations: boolean;
    }>(`problem/nearby-contexts`, problem);

    return {
      contexts,
      isDestAvailable,
    };
  } catch (e) {
    return {
      contexts: [],
      isDestAvailable: false,
    };
  }
}
